export default __webpack_public_path__ + "static/media/inboxLogo_01.42782d6f.svg";